import { useTranslation } from 'react-i18next'
import { Modal, AcknowledgeModal } from '@percent/lemonade'

export type CancelOpportunityFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function CancelOpportunityFailureModal({ isOpen, handleClose }: CancelOpportunityFailureModalProps) {
  const { t } = useTranslation()
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <AcknowledgeModal
        result="negative"
        title={t('volunteering.actionsMenu.cancelOpportunity.cancelOpportunityFailureModal.title')}
        description={t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
